import { Box, H3, Stack, Text, Spinner } from "@adfenix/alexandria";
import { useTranslation } from "react-i18next";

const AskingPermissionPage = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing="xs" pY="xl5" pX="xl5">
      <Box display="flex" justifyContent="center">
        <Spinner size={72} />
      </Box>
      <Box display="flex" justifyContent="center">
        <H3>{t("selfonboarding.message.askingPermission.title")}</H3>
      </Box>
      <Box display="flex" justifyContent="center">
        <Text>{t("selfonboarding.message.askingPermission.description")}</Text>
      </Box>
    </Stack>
  );
};

export default AskingPermissionPage;
